import React, { useState, useEffect } from 'react';
import Location from '../../../constants/Location.json';
import { DropdownComponent } from '../../core/Forms';
 import useJsonData from '../../../hooks/useJsonData';

interface LocationData {
  name: string;
  cities: string[]; 
}

interface LocationSelectorProps {
  onLocationChange: (state: string, cities: string[]) => void;
  onError: (error: string) => void;
  selectedState: string; 
  selectedCity: string; 
}

interface DropdownOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

const LocationSelector: React.FC<LocationSelectorProps> = ({ onLocationChange, onError,  selectedState,
  selectedCity}) => {
  const [, setSelectedState] = useState<string>('');
  const [, setSelectedCity] = useState<string>('');
  const [isCityDisabled, setIsCityDisabled] = useState<boolean>(true);

  useEffect(() => {
    setIsCityDisabled(!selectedState);
  }, [selectedState]);

  useEffect(() => {
    if (selectedState && !selectedCity) {
      onError('Please select a city.');
    } else {
      onError('');
    }
  }, [selectedState, selectedCity, onError]);

  const handleStateChange = (name: string, value: string) => {
    console.log('Selected State:', value);
    setSelectedState(value);

    if (value) {
      const selectedStateData = Location.find((state: LocationData) => state.name === value);
      const citiesForState = selectedStateData?.cities || [];
      setSelectedCity('');
      onLocationChange(value, citiesForState);
    } else {
      setSelectedCity('');
      onLocationChange('', []);
    }
  };

  const handleCityChange = (name: string, value: string) => {
    console.log('Selected City:', value);
    setSelectedCity(value);
    if (selectedState) {
      onLocationChange(selectedState, [value]);
    }
  };

  const stateOptions: DropdownOption[] = Location.map((state: LocationData) => ({
    value: state.name,
    label: state.name,
  }));

  const selectedStateData = Location.find((state: LocationData) => state.name === selectedState);
  const cityOptions: DropdownOption[] =
    selectedStateData?.cities.map((city: string) => ({
      value: city,
      label: city,
    })) || [];

  return (
    <div className='relative'>
       <label
              htmlFor="city"
              className=" text-[12px] md:text-[13px] flex justify-start xl:font-sm xl:text-[13px] xl:text-black xl:mt-[5em] "
            >
              State
            </label>
      <DropdownComponent
        options={stateOptions}
        name="state"
        value={selectedState}
        placeholder="Select a state"
        onChange={handleStateChange}
        iconClassName="ml-[-2em] mt-[3px]"
        selectedValue={selectedState}
        dropdownClassName="  z-10 max-h-52 overflow-y-auto bg-white border border-gray-300 left-0 right-0 top-full"
      />

      {selectedState && (
  <div className='mt-[1em]'>
    <label
          htmlFor="city"
          className=" text-[12px] md:text-[13px] flex justify-start xl:font-sm xl:text-[13px] xl:text-black xl:ml-[em] xl:mt-[1em] "
        >
          City
        </label><DropdownComponent
            options={cityOptions}
            name="city"
            value={selectedCity}
            placeholder="Select a city"
            onChange={handleCityChange}
            disabled={isCityDisabled}
            iconClassName="ml-[-2em] mt-[3px]"
            dropdownClassName=" z-10 max-h-52 overflow-y-auto bg-white border border-gray-300 left-0 right-0 top-full"
            selectedValue={selectedCity} />
            </div>
      )}
    </div>
    //  </div>
  );
};

export default LocationSelector;
